import Profile from './profile';

export default class OrganizerProfile extends Profile {
  constructor(profile = {}, url = '') {
    super(profile, url);

    this.type_id = profile?.type_id || null;
    this.short_name = profile?.short_name || null;
    this.pfdo_id = profile?.pfdo_id || null;
    this.legal_address = profile?.legal_address || null;
    this.inn = profile?.inn || null;
    this.head_full_name = profile?.head_full_name || null;
    this.full_name = profile?.full_name || null;
    this.fact_address = profile?.fact_address || null;
    this.contact_phone = profile?.contact_phone || null;
    this.contact_email = profile?.contact_email || null;
    this.contact_full_name = profile?.contact_full_name || null;

    this.ground = profile?.ground;

    this.kpp = profile.kpp || null;
    this.edu_type = profile.edu_type || null;

    this.is_full_data = profile.is_full_data ?? true;
    this.empty_fields = profile.empty_fields || [];

    this.created_at = profile?.created_at || null;
    this.updated_at = profile?.updated_at || null;
  }

  get displayName() {
    const { short_name, full_name } = this;
    return short_name?.length < full_name?.length ? short_name : full_name;
  }

  get displayFullName() {
    const { short_name, full_name } = this;
    return short_name?.length < full_name?.length ? full_name : short_name;
  }
}
